import { useState } from 'react'
import { useDispatch } from 'react-redux'
import Stack from '@mui/material/Stack'
import TextButton from 'components/TextButton'
import Icon from 'components/Icon'
import Type from 'components/Type'
import ModalFlow from 'components/ModalFlow'
import IconError from 'components/CommonUI/IconError'
import StandardModal from 'components/CommonUI/StandardModal'
import AllSet from 'components/ModalViews/AllSet'
import { useTypeLoad } from 'utils/hooks'
import { useAction } from 'utils/actions'
import { REMOVE_CORPORATE_EXTERNAL_CARD } from 'api/constants'

const RemoveCorporateExternalCard = ({
  card,
  onRemove,
}) => {
  const dispatch = useDispatch()
  const { closeModal } = useAction()
  const [activeIndex, setActiveIndex] = useState(0)

  const handleRemoveCard = () => {
    setActiveIndex(-1)
    onRemove()
  }

  useTypeLoad(REMOVE_CORPORATE_EXTERNAL_CARD, data => {
    if (!data.error) setActiveIndex(1)
  })

  return (
    <ModalFlow
      sizeX="md"
      activeIndex={activeIndex}
      setActiveIndex={setActiveIndex}
    >
      {/* SAVE CARD */}
      <StandardModal
        title="Are you sure?"
        subtitle={`You are forgetting the company card ending in ${card.last_four}`}
        body="You can continue purchasing company points by entering new card information"
        icon="CelCardRemove"
        iconProps={{
          width: 50,
          height: 50,
        }}
        // iconError
        frameIcon
        actionOne={(
          <span
            onClick={handleRemoveCard}
          >
            Yes, forget card
          </span>
        )}
        actionTwo="Never mind"
        closeModalAction="two"
      />
      {/* ALL SET */}
      <AllSet />
    </ModalFlow>
  )
}

export default RemoveCorporateExternalCard